module.exports = __webpack_public_path__ + "static/media/uiux.c35bdc33.svg";